import { TAG_VARIANT, TagVariant } from '@savgroup-front-common/core/src/atoms/Tag/Tag.types';

import type { DossierRow } from '../types/dossier.types';

const DOSSIER_STATUT_TAG_VARIANTS: Record<string, TagVariant> = {
  'Dossier cloturé': TAG_VARIANT.SUCCESS,
  "Deuxième relance envoyée à l'acteur du dossier": TAG_VARIANT.ALERT,
  'Colis pris en charge par le transporteur': TAG_VARIANT.PRIMARY,
  "En attente d'expédition [RMA automatique]": TAG_VARIANT.NEUTRAL,
  'Demande RMA en attente de confirmation par le fournisseur [RMA manuelle]': TAG_VARIANT.ALERT,
};

const DOSSIER_STATUT_SHORT_LABELS: Record<string, string> = {
  'Dossier cloturé': 'Clôturé',
  "Deuxième relance envoyée à l'acteur du dossier": 'Relance',
  'Colis pris en charge par le transporteur': 'En transit',
  "En attente d'expédition [RMA automatique]": 'Expédition',
  'Demande RMA en attente de confirmation par le fournisseur [RMA manuelle]': 'RMA',
};

export interface DossierStatutFilterOption {
  statut: string;
  shortLabel: string;
}

export const getDossierStatutTagVariant = (statut: string): TagVariant =>
  DOSSIER_STATUT_TAG_VARIANTS[statut] ?? TAG_VARIANT.NEUTRAL;

export const getDossierStatutShortLabel = (statut: string): string =>
  DOSSIER_STATUT_SHORT_LABELS[statut] ?? statut;

export const getDossierStatutFilterOptions = (dossiers: DossierRow[]): DossierStatutFilterOption[] => {
  const uniqueStatuts = [...new Set(dossiers.map((dossier) => dossier.statut))];

  return uniqueStatuts
    .map((statut) => ({
      statut,
      shortLabel: getDossierStatutShortLabel(statut),
    }))
    .sort((left, right) => left.shortLabel.localeCompare(right.shortLabel, 'fr'));
};

export const filterDossiersByStatut = (
  dossiers: DossierRow[],
  selectedStatut: string | undefined,
): DossierRow[] => {
  if (!selectedStatut) {
    return dossiers;
  }

  return dossiers.filter((dossier) => dossier.statut === selectedStatut);
};
